import {
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	FormWrapperLabel,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { Controller } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useEffect, useRef } from 'react';
import { MailType } from '../../../Types/MailFilterDataTypes';
import { SearchTypesType } from '../SearchControlTypes';

function SearchMailType(props: SearchTypesType) {
	const { t } = useTranslation();

	const inputRef = useRef<HTMLInputElement | null>(null);

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.value = props.searchParams?.get('mailType')
				? (props.searchParams.get('mailType') as string)
				: '';
		}
	}, [props.searchParams]);

	return (
		<Controller
			name='mailType'
			control={props.formMethods.control}
			render={({ field, fieldState }) => (
				<FormWrapperLabel
					label={t('mailboxes.filter.labels.mailType')}
					invalid={fieldState.invalid}
					validationMessage={fieldState.error?.message}
				>
					<ComboBoxControl
						name='mailType'
						placeholder={t('mailboxes.filter.controls.mailTypePlaceholder')}
						data={MailType}
						valueType='number'
						displayType={ComboBoxTypeEnum.Single}
						displayItemLabelType={ComboBoxItemDisplayEnum.Label}
						defaultValue={
							props.searchParams?.get('mailType') ? [props.searchParams?.get('mailType')] : undefined
						}
						forwardValueCallback={(e) => {
							field.onChange(e);
						}}
					/>
				</FormWrapperLabel>
			)}
		/>
	);
}

export { SearchMailType };
